<template>
    <Column
        :xs-size="xsSize"
        :sm-size="smSize"
        :md-size="mdSize"
        :lg-size="lgSize"
        :xl-size="xlSize"
        :no-margin-top="noMarginTop"
    >
        <LabelTag> {{ $t(title) }}</LabelTag>

        <VueTreeselect
            class="p-0 form-control border-gray-300 h-11"
            v-model="modelForm[modelName]"
            openDirection="below"
            :multiple="multiple"
            :flat="multiple"
            :default-expand-level="100"
            :normalizer="normalizer"
            :options="options"
            :placeholder="$t(placeholder)"
            :noChildrenText="$t('empty')"
            :noOptionsText="$t('noData')"
            :clearValueText="$t('delete')"
            :always-open="isAlwaysOpen"
            @input="setCategory"
            valueFormat="object"
            :disabled="isDisabled"
        />

        <InvalidForm
            v-if="checkToModel !== undefined"
            :state="this[checkToModel](modelName)"
            :text="errors[modelName]"/>
    </Column>
</template>

<script>
import Column from "./html/Column";
import LabelTag from "./html/LabelTag";
import sizeClassesMixin from "./html/mixin/sizeClassesMixin";
import InvalidForm from "./html/InvalidForm";
import validatorMixin from "../mixin/validatorMixin";
import VueTreeselect from "@riophae/vue-treeselect"
import "@riophae/vue-treeselect/dist/vue-treeselect.min.css"

export default {
    name: "TreeCheckBoxForAddMany",
    mixins: [validatorMixin, sizeClassesMixin],
    components: {InvalidForm, LabelTag, Column, VueTreeselect},
    methods: {
        normalizer(object) {
            object.label = object.name

            if (object.children && object.children.length === 0) {
                object.children = undefined
            }
        }
    },
    props: {
        isAlwaysOpen: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        options: {
            type: Array,
            required: true,
        },
        modelForm: {
            type: Object,
            required: true,
        },
        modelName: {
            type: String,
            required: true,
        },
        setCategory: {
            type: Function,
            default: () => {}
        },

        // optional
        errors: {
            type: Object,
            default: null,
        },
        checkToModel: {
            type: String,
            default: undefined
        },
        title: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "select",
        },
        type: {
            type: String,
            default: "text",
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        isNeedIntId: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: "id",
        },

        // column
        noMarginTop: {
            type: Boolean,
            default: false
        },

    }
}
</script>

<style>
.vue-treeselect--single .vue-treeselect__input {
    width: auto;
    height: auto;
}

.vue-treeselect__control {
    border: none !important;
}

.vue-treeselect--disabled .vue-treeselect__control {
    background-color: #fff;
}
</style>